<template>
  <li v-if="link" class="w-full sm:w-1/2 lg:w-1/3 px-4 mb-8">
    <div
      class="border-1 border-lightGreen p-8 rounded-md bg-white drop-shadow-[0_4px_30px_0px_rgba(0,0,0,0.25)]"
    >
      <div class="flex flex-col items-center">
        <div
          v-if="icon"
          class="size-54 bg-[#DAFAD5] rounded-full flex items-center justify-center mb-10"
        >
          <MediaIcon
            v-bind="icon"
            class="mx-10 mt-0 size-[135px] fill-darkGreen text-darkGreen lg:mx-0"
          />
        </div>
      </div>
      <VuepalLink
        :to="link.url?.path"
        class="text-lg font-bold lg:text-xl flex flex-row justify-between items-center group text-darkGreen hover:text-violet"
      >
        <span>{{ link.label }}</span>
        <SpriteSymbol
          name="arrow-right"
          class="size-6 flex-[0_1_10%] text-lightGreen transition-all duration-250 ease-in-out mr-1 group-hover:mr-0 group-hover:text-violet"
        />
      </VuepalLink>
      <ul v-if="children.length" class="mt-5 grid gap-4 xl:mt-4">
        <li v-for="(child, key) in children" :key="key">
          <VuepalLink
            class="text-base text-darkGreen hover:text-violet group flex flex-row justify-between items-center"
            :to="child.to"
          >
            {{ child.title }}
            <SpriteSymbol
              name="arrow-right"
              class="size-5 opacity-0 text-lightGreen transition-all duration-250 ease-in-out mr-1 group-hover:mr-0 group-hover:opacity-100 group-hover:text-violet"
            />
          </VuepalLink>
        </li>
      </ul>
    </div>
  </li>
</template>

<script lang="ts" setup>
import type {
  MediaIconFragment,
  TopicTeaserFragment,
} from '#graphql-operations'

type MenuListLink = TopicTeaserFragment

const props = defineProps<{
  link?: MenuListLink['link']
  subtree?: MenuListLink['subtree']
  heading?: 'h2' | 'h3'
  withIcon?: boolean
}>()

const children = computed(() => {
  return (
    props.subtree
      ?.filter((v) => v.link?.url?.path)
      .map((v) => {
        return {
          title: v.link.label,
          to: v.link.url?.path,
        }
      }) || []
  )
})

const icon = computed<MediaIconFragment | undefined>(() => {
  const url = props.link?.url
  if (url && 'entity' in url) {
    const entity = url.entity
    if (entity && 'icon' in entity) {
      return entity.icon
    }
  }
  return undefined
})

defineOptions({
  name: 'MenuListItem',
})
</script>
